$(document).ready(() => {
  $('#broadcast_message_schedule_for_collapse')
    .on('shown.bs.collapse', () => {
      $('#submit-button').val($('#when_scheduled').text())
    })
    .on('hidden.bs.collapse', () => {
      $('#submit-button').val($('#when_not_scheduled').text())
    });
})
